export default __webpack_public_path__ + "static/media/shipment.00a5eb68.svg";